<template>
    <div class="comicList_1">
        <div class="comicList_1-item cursorPointer" style="width: 200px;" v-for="(item,index) in dataList" :key="index" @click="navToDetail(item.comicId)" >
            <img  @dragstart.prevent  style="width: 200px; height:300px" :src="item.realCoverUrl" alt="">
            <span class="txtOverFlow1">{{item.comicName}}</span>
        </div>
    </div>
</template>

<script setup>
import { navTo, navToDetail } from '../utils/utils'
const props = defineProps({
  dataList: Array,
});
</script>

<style lang="scss" scoped>
.comicList_1{
    width: 1188px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 65px;
    // justify-content: space-between;
    border-radius: 8px;
    &-item{
        margin-bottom: 30px;
        margin-right: 30px;
        span{
            width: 200px;
            font-size: 18px;
            color: #333333;
            line-height: 25px;
        }
        img{
            border-radius: 8px;
        }
    }
}
</style>